export class CheckUnreadMessages {
  public static readonly type = '[Messaging] Check unread messages';
}

export class ReadMessage {
  public static readonly type = '[Messaging] Read message';
  constructor(public readonly messageId: number) {}
}
